import {FormStates} from '../Types';
import {SensorStep} from '../../Dashboard/Sensor/AddSensor/GetSensorSteps';
import {LimitAlarmFormState} from '../../Dashboard/Sensor/Forms/LimitAlarmForm/LimitAlarmFormState';
import {PositionedSensors} from '../../../common/util/LicenseUtils/LineItemConstants';
import {LineItem} from '../../../common/util/LicenseUtils/LineItem';
import {DeviceUtils} from '../../../common/util';
import {EcologProXGType} from '../../../common/constants/DeviceType';
import {DeviceFamily} from '../../../common/constants';

type FormStateAndSteps = {formStates: FormStates; steps: SensorStep[]};

export function ExportFormStateAndSteps(
	state: FormStateAndSteps,
	index: number,
	limitAlarmFormState: Partial<LimitAlarmFormState>
): FormStateAndSteps {
	let formStates = state.formStates ?? {predictiveForm: null, limitAlarmForms: [], issueAlarmForm: null};
	let limitAlarmFormStates = formStates.limitAlarmForms ?? [];
	limitAlarmFormStates[index] = {...limitAlarmFormStates[index], ...limitAlarmFormState};

	let steps = state.steps;

	formStates.limitAlarmForms = limitAlarmFormStates;

	return {steps: steps, formStates: formStates};
}

export function IsLineItemForSelectedSensor(lineItem: LineItem, channelNumber: number, valueIndex: number): boolean {
	return lineItem.internalPriceId.endsWith(PositionedSensors[channelNumber][valueIndex]);
}

export function GetDefaultLoggingInterval(serialNumber: string): number {
	let loggingInterval = 600;
	if (
		DeviceUtils.GetDeviceType(serialNumber) === EcologProXGType.OneTHGi ||
		DeviceUtils.GetDeviceFamily(serialNumber) === DeviceFamily.LiberoGx
	) {
		loggingInterval = 900;
	}
	return loggingInterval;
}

export interface QueryParameters {
	variableName: string;
	items: string[];
}

export function PrepareQueryString(objectArray: QueryParameters[]): string {
	try {
		let queryStrings: string[] = [];

		objectArray.forEach(o => {
			o.items.forEach((i: string) => queryStrings.push(`${o.variableName}=${i}`));
		});

		return queryStrings.join('&');
	} catch (error) {
		console.error('Error while preparing query string:', error);
		throw error;
	}
}
